import React from 'react'
import PropTypes from 'prop-types'

import { setHeaderStyle } from './config'
import { CloseWidgetIcon, MinusIcon } from '../../../icons/Icons'
import ResizeButton from '../../resizeButton/ResizeButton'

import classes from './styles.module.scss'

import { useEndConversationModalContext } from '../../EndConversationModal/context'

const Header = ({
  header,
  isMobile,
  widgetColor,
  widgetLogo,
  isFullScreenWidget,
  resizeWidget,
  handleHiddenWidget
}) => {
  const { setIsOpenEndConversationModal } = useEndConversationModalContext()

  const onClose = () => {
    setIsOpenEndConversationModal(true)
  }

  return (
    <div
      className={classes.wrap}
      style={setHeaderStyle(widgetColor, isFullScreenWidget)}>
      <div className={classes.botInfo}>
        <img src={widgetLogo} alt={header} className={classes.logo} />
        <p className={classes.name}>{header}</p>
      </div>
      <div className={classes.buttonsBlock}>
        {!isMobile && (
          <ResizeButton isLarge={isFullScreenWidget} onClick={resizeWidget} />
        )}
        <div onClick={handleHiddenWidget} className={classes.xIcon}>
          <MinusIcon />
        </div>
        <div onClick={onClose} className={classes.xIcon}>
          <CloseWidgetIcon />
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  isMobile: PropTypes.bool,
  botName: PropTypes.string,
  widgetLogo: PropTypes.string,
  widgetColor: PropTypes.string,
  classes: PropTypes.object,
  resizeWidget: PropTypes.func,
  toggleWidget: PropTypes.func,
  isFullScreenWidget: PropTypes.bool,
}

export default Header
